<template>
  <div class="text-xs-center">
    <v-menu offset-y :disabled="loading">
      <v-btn
        slot="activator"
        color="primary"
        small
        class="text-none mx-3"
        :loading="loading"
      >
        {{ currentLabel }}
      </v-btn>

      <v-list>
        <v-list-tile
          v-for="(item, index) in menuOptions"
          :key="index"
          @click="openConfirmDialog(item.value)"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-dialog v-model="dialogConfirm" max-width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2">{{
          $t("change-binary-direction")
        }}</v-card-title>
        <v-card-text>
          <span
            v-html="
              $t('change-binary-direction-from-to', [currentLabel, nextLabel])
            "
          ></span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-unset"
            small
            light
            flat
            @click="dialogConfirm = false"
            >{{ $t("common.no") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-unset"
            small
            dark
            @click="confirmChange"
            >{{ $t("common.yes") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSuccess" max-width="300">
      <v-card>
        <v-card-text class="text-xs-center pt-4">
          {{ $t("binary-direction-changed") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-unset"
            small
            darkflat
            @click="dialogSuccess = false"
            >Ok</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import gql from "graphql-tag";

const UPDATE_INVITE_MUTATION = gql`
  mutation UpdateInvite($leg: Int!) {
    updateInvite(leg: $leg)
  }
`;

export default {
  name: "LegSelector",
  props: {
    leg: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      dialogConfirm: false,
      dialogSuccess: false,
      pendingValue: null, // Shranimo novo vrednost, dokler uporabnik ne potrdi
    };
  },
  computed: {
    menuOptions() {
      return [
        { title: this.$i18n.t("leg-auto"), value: 0 },
        { title: this.$i18n.t("leg-left"), value: 1 },
        { title: this.$i18n.t("leg-right"), value: 2 },
      ];
    },
    currentLabel() {
      const activeOption = this.menuOptions.find(
        (opt) => opt.value === this.leg
      );
      return activeOption ? activeOption.title : "";
    },
    nextLabel() {
      const nextOption = this.menuOptions.find(
        (opt) => opt.value === this.pendingValue
      );
      return nextOption ? nextOption.title : "";
    },
  },
  methods: {
    // Odpre prvo okno in pripravi vrednost za potrditev
    openConfirmDialog(value) {
      if (value === this.leg) return;
      this.pendingValue = value;
      this.dialogConfirm = true;
    },

    // Dejanski klic na strežnik po kliku na "Yes"
    async confirmChange() {
      this.dialogConfirm = false; // Zapremo potrditveno okno
      this.loading = true;

      try {
        const result = await this.$apollo.mutate({
          mutation: UPDATE_INVITE_MUTATION,
          variables: { leg: this.pendingValue },
        });

        if (result.data && result.data.updateInvite) {
          // 1. Posodobimo podatek pri staršu
          this.$emit("update:leg", this.pendingValue);
          // 2. Odpremo okno za uspeh
          this.dialogSuccess = true;
        }
      } catch (error) {
        console.error("GraphQL error:", error);
        alert("There was an error updating the direction.");
      } finally {
        this.loading = false;
        this.pendingValue = null;
      }
    },
  },
};
</script>

<style scoped>
.text-none {
  text-transform: none !important;
}
</style>